import CookiesRepository from "../../repository/CookiesRepository"

/* eslint-disable camelcase */
export type ConfirmIframeProps = {
  brandID: string;
  spaUUID: string;
  utbPath: string;
  pin: string;
  langCode: string;
};

export class ConfirmIframePathBuilder {
  private readonly utbPath: string
  private readonly cookies: Record<string, any>
  private readonly brandID: string
  private readonly spaUUID: string
  private readonly pin: string
  private readonly langCode: string

  public constructor({ utbPath, brandID, spaUUID, pin, langCode }: ConfirmIframeProps) {
    this.utbPath = utbPath
    this.cookies = CookiesRepository.getCookiesAsObject('klaro')
    this.brandID = brandID
    this.spaUUID = spaUUID
    this.pin = pin
    this.langCode = langCode
  }

  private buildBase() {
    return `https://160-${this.brandID}.engine.spalopia.com/engine/${this.spaUUID}/channel/spalopia`
  }

  public buildPath() {
    const cookieQuery = this.cookies
      ? ('').concat(`&utb_consent_google-analytics=${Number(this.cookies['google-analytics'])}`)
          .concat(`&utb_consent_facebook=${Number(this.cookies.facebook)}`)
          .concat(`&utb_consent_fullstory=${Number(this.cookies['spalopia-booking-engine'])}`)
      : ''

    return this.utbPath
      .concat(`&utb_d3226782744ce122d789ea8e03d32f53=e6605c20f4c728459cdbe54e3515110d=${this.pin}`)
      .concat(`&utb_lang=${this.langCode}`)
      .concat(cookieQuery)
  }

  public build() {
    return {
      base: this.buildBase(),
      path: this.buildPath(),
    }
  }
}
